/* global nienhuys */

const getOccupancy = async (id) => {
  const { nienhuys } = window;

  const formData = new FormData();
  formData.append('action', 'getOccupancy');
  formData.append('nonce',  nienhuys.nonce);
  formData.append('occupancy', (id ? id : nienhuys.id));

  let response = await fetch(nienhuys.ajaxurl, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};


export default getOccupancy;
